import { NavLink, useNavigate } from 'react-router-dom';
import { CustomNavLink } from '../route-handler/custom-nav';
import Logo from '../../assets/images/brand/logo.png';
import { useUser } from '../../contexts/user';
import { Dropdown } from 'rsuite';
import { ROLE_CONVERTOR } from '../../utils/helpers';
export const Header = () => {
  const { isUserRole, user, handleSetSelectedRole } = useUser();
  const navigate = useNavigate();

  return (
    <ul className="h-14 bg-[--rs-primary-200] flex  text-xs text-[--rs-white]">
      <NavLink
        to={'/'}
        className={`nav-item flex items-center text-[--rs-primary-800] px-5 h-full`}>
        <img src={Logo} alt="RCG Logo" className="max-h-[100%]" />
      </NavLink>
      {!isUserRole('Admin') ? (
        <li>
          {' '}
          <CustomNavLink to="/consultants" title="صفحه اصلی مشاوران" />
        </li>
      ) : null}
      {!isUserRole('Admin') ? (
        <li>
          {' '}
          <CustomNavLink to="/choose-role" title="درخواست نقش" />
        </li>
      ) : null}
      {isUserRole('Admin') ? (
        <li>
          {' '}
          <CustomNavLink to="/admin/register-consultant-list" title="درخواست های مشاور" />
        </li>
      ) : null}
      {isUserRole('User') ? (
        <li>
          {' '}
          <CustomNavLink to="/user/requests" title="جلسات شما" />
        </li>
      ) : null}
      {isUserRole('Consultant') ? (
        <li>
          {' '}
          <CustomNavLink to="/consultant/requests" title="جلسات شما" />
        </li>
      ) : null}
      {/*  */}
      <li className="mr-auto ml-5 flex">
        {/* {' '}
        <CustomNavLink
          to="/"
          title={
            isUserRole('Consultant')
              ? 'مشاور'
              : isUserRole('User')
                ? 'کاربر'
                : isUserRole('Admin')
                  ? 'ادمین'
                  : ''
          }
        /> */}
        <Dropdown
          title={`نقش ${ROLE_CONVERTOR[user.selectedRole]}`}
          className="custom-navlink-dropdown"
          appearance="primary">
          {user.Roles.map((role: string) => (
            <Dropdown.Item
              key={role}
              onClick={() => {
                handleSetSelectedRole(role);
                navigate('/');
              }}>
              {ROLE_CONVERTOR[role]}
            </Dropdown.Item>
          ))}
        </Dropdown>
        <CustomNavLink to="/logout" title="خروج" />
        {/* <CustomNavLink to="/a" title="نام و نام خانوادگی" /> */}
      </li>
    </ul>
  );
};
